// type 定義を types/ に集約
export type PokemonType = 1|2|3|4|5|6|7|8|9|10|11|12|13|14|15|16|17|18|19;

export const POKEMON_TYPE_NORMAL: PokemonType = 1;
export const POKEMON_TYPE_FIGHTING: PokemonType = 2;
export const POKEMON_TYPE_FLYING: PokemonType = 3;
export const POKEMON_TYPE_POISON: PokemonType = 4;
export const POKEMON_TYPE_GROUND: PokemonType = 5;
export const POKEMON_TYPE_ROCK: PokemonType = 6;
export const POKEMON_TYPE_BUG: PokemonType = 7;
export const POKEMON_TYPE_GHOST: PokemonType = 8;
export const POKEMON_TYPE_STEEL: PokemonType = 9;
export const POKEMON_TYPE_FIRE: PokemonType = 10;
export const POKEMON_TYPE_WATER: PokemonType = 11;
export const POKEMON_TYPE_GRASS: PokemonType = 12;
export const POKEMON_TYPE_ELECTRIC: PokemonType = 13;
export const POKEMON_TYPE_PSYCHIC: PokemonType = 14;
export const POKEMON_TYPE_ICE: PokemonType = 15;
export const POKEMON_TYPE_DRAGON: PokemonType = 16;
export const POKEMON_TYPE_DARK: PokemonType = 17;
export const POKEMON_TYPE_FAIRY: PokemonType = 18;
export const POKEMON_TYPE_STERA: PokemonType = 19;
